import React from "react";

import FixedHeightWrapper from "app/meets/FixedHeightWrapper";
import RefsTable from "./RefsTable";

import "./RefsIndex.scss";
import { useMeet } from "util/useMeet";

const RefsIndex = () => {
  const meet = useMeet();

  return (
    <FixedHeightWrapper>
      <div className="refs-index">
        <div className="util-row-wrapper">
          <div className="util-row">
            Add refs and other official meet positions to be exported with
            results
          </div>
        </div>
        <div className="table-wrapper">
          <RefsTable meet={meet} refs={meet.restricted.refs || {}} />
        </div>
      </div>
    </FixedHeightWrapper>
  );
};

export default RefsIndex;
